import type { FormEvent } from "react";

import { Button, Input } from "@/atoms";
import { strings } from "@/constants";
import { ButtonTypeEnum, ButtonVariantEnum, InputTypeEnum } from "@/enums";

export interface RegisterFormFieldsInterface {
    companyName: string,
    confirmPassword: string,
    email: string,
    name: string,
    password: string,
    phone: string,
}

export interface RegisterFormPropsInterface {
    error: string,
    fields: RegisterFormFieldsInterface,
    isLoading: boolean,
    onBackToLogin: () => void,
    onChangeField: (key: keyof RegisterFormFieldsInterface, value: string) => void,
    onSubmit: (event: FormEvent<HTMLFormElement>) => void,
}

export const RegisterForm = ({
    error,
    fields,
    isLoading,
    onBackToLogin,
    onChangeField,
    onSubmit,
}: RegisterFormPropsInterface) => (
    <>
        <form
            className="space-y-5"
            onSubmit={onSubmit}
        >
            <Input
                hasError={!!error}
                label={strings.register.nameLabel}
                placeholder={strings.register.namePlaceholder}
                type={InputTypeEnum.TEXT}
                value={fields.name}
                onChange={({ target }) => onChangeField(
                    "name",
                    target.value,
                )}
            />
            <Input
                hasError={!!error}
                label={strings.register.companyNameLabel}
                placeholder={strings.register.companyNamePlaceholder}
                type={InputTypeEnum.TEXT}
                value={fields.companyName}
                onChange={({ target }) => onChangeField(
                    "companyName",
                    target.value,
                )}
            />
            <Input
                hasError={!!error}
                label={strings.register.phoneLabel}
                placeholder={strings.register.phonePlaceholder}
                type={InputTypeEnum.TEL}
                value={fields.phone}
                onChange={({ target }) => onChangeField(
                    "phone",
                    target.value,
                )}
            />
            <Input
                hasError={!!error}
                label={strings.register.passwordLabel}
                placeholder={strings.register.passwordPlaceholder}
                type={InputTypeEnum.PASSWORD}
                value={fields.password}
                isShowPasswordToggle
                onChange={({ target }) => onChangeField(
                    "password",
                    target.value,
                )}
            />
            <Input
                hasError={!!error}
                label={strings.register.confirmPasswordLabel}
                placeholder={strings.register.confirmPasswordPlaceholder}
                type={InputTypeEnum.PASSWORD}
                value={fields.confirmPassword}
                isShowPasswordToggle
                onChange={({ target }) => onChangeField(
                    "confirmPassword",
                    target.value,
                )}
            />
            <Button
                isLoading={isLoading}
                type={ButtonTypeEnum.SUBMIT}
                isFullWidth
            >
                {strings.register.submitButton}
            </Button>
        </form>
        <div className="mt-4 text-center">
            <Button
                variant={ButtonVariantEnum.LINK}
                onClick={onBackToLogin}
            >
                {strings.register.backToLogin}
            </Button>
        </div>
    </>
);
